import { apiClient } from "@wtf/shared/api/utils/api-client";
import {
  BlockUserRequest,
  BlockUserResponse,
  UnblockUserResponse,
  GetBlockedUsersResponse,
  BlockStatusResponse,
} from "@wtf/shared";

/**
 * Block a user
 */
export async function blockUser(userId: string, data?: BlockUserRequest): Promise<BlockUserResponse> {
  return apiClient<BlockUserResponse>(`api/users/${userId}/block`, "POST", data);
}

/**
 * Unblock a user
 */
export async function unblockUser(userId: string): Promise<UnblockUserResponse> {
  return apiClient<UnblockUserResponse>(`api/users/${userId}/block`, "DELETE");
}

/**
 * Get list of users the current user has blocked
 */
export async function getBlockedUsers(): Promise<GetBlockedUsersResponse> {
  return apiClient<GetBlockedUsersResponse>(`api/users/me/blocked`, "GET");
}

/**
 * Check if the current user has blocked a specific user
 */
export async function getBlockStatus(userId: string): Promise<BlockStatusResponse> {
  return apiClient<BlockStatusResponse>(`api/users/${userId}/block/status`, "GET");
}

export const blocksApi = {
  blockUser,
  unblockUser,
  getBlockedUsers,
  getBlockStatus,
};
